import { render, staticRenderFns } from "./panel_actions_portal.vue.js?vue&type=template&id=20022ca9!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./panel_actions_portal.vue?vue&type=template&id=20022ca9"
import script from "./panel_actions_portal.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./panel_actions_portal.vue?vue&type=script&lang=js"
export * from "./panel_actions_portal.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./panel_actions_portal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports